import { render, staticRenderFns } from "./GalleryProperty.vue?vue&type=template&id=789c496d&scoped=true&"
import script from "./GalleryProperty.vue?vue&type=script&lang=js&"
export * from "./GalleryProperty.vue?vue&type=script&lang=js&"
import style0 from "./GalleryProperty.vue?vue&type=style&index=0&id=789c496d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c496d",
  null
  
)

export default component.exports